



// import React, { useContext } from "react";
// import Rightcontainer from "../Components/Rightcontainer";
// import { LanguageContext } from "../Components/LanguageContext";
// import { RiTelegramFill, RiWhatsappFill, RiCustomerService2Fill } from "react-icons/ri";
// import { BsShieldCheck, BsClockHistory, BsArrowRightShort } from "react-icons/bs";
// // import "./Support.css";

// const Support = () => {
//   const { language } = useContext(LanguageContext);

//   // Get settings from localStorage safely
//   const siteSetting = JSON.parse(localStorage.getItem("sitSetting")) || {};

//   const translations = {
//     hi: {
//       help: "24/7 सहायता केंद्र",
//       sub: "क्या आपको कोई समस्या है? हम सहायता के लिए यहाँ हैं",
//       contact: "संपर्क माध्यम चुनें",
//       telegram: "टेलीग्राम सपोर्ट",
//       whatsapp: "व्हाट्सएप चैट",
//       quick: "त्वरित प्रतिक्रिया (2-5 मिनट)",
//       instant: "इंस्टेंट चैट सहायता",
//       secure: "100% सुरक्षित और गोपनीय सहायता",
//       online: "ऑनलाइन एजेंट उपलब्ध हैं",
//     },
//     en: {
//       help: "24/7 Support Center",
//       sub: "Having an issue? Our team is active & ready to assist",
//       contact: "Choose a contact channel",
//       telegram: "Telegram Support",
//       whatsapp: "WhatsApp Chat",
//       quick: "Quick Response (2-5 mins)",
//       instant: "Instant live chat support",
//       secure: "100% Secure & Confidential Support",
//       online: "Live Agents Online",
//     },
//   };

//   const t = translations[language] || translations.en;

//   const telegramLink = siteSetting.supportTelegram || "https://t.me/";
//   const whatsappLink = siteSetting.whatsappSupport || "https://wa.me/";

//   return (
//     <div className="sa-support-wrapper leftContainer mt-5 pt-5">
//       {/* Background ambient lighting blurs */}
//       <div className="sa-support-ambient glow-1"></div>
//       <div className="sa-support-ambient glow-2"></div>

//       <div className="sa-support-container mb-5">
        
//         {/* Header Hero Card */}
//         <div className="sa-support-hero">
//           <div className="sa-hero-glow"></div>
          
//           <div className="sa-hero-top">
//             <div className="sa-online-status">
//               <span className="sa-pulse-dot"></span>
//               <span>{t.online}</span>
//             </div>
//           </div>

//           <div className="sa-support-header">
//             <div className="sa-help-icon-wrap">
//               <RiCustomerService2Fill className="sa-main-icon" />
//             </div>
//             <h1 className="sa-support-title">{t.help}</h1>
//             <p className="sa-support-sub">{t.sub}</p>
//           </div>
//         </div>

//         {/* Channels Section */}
//         <div className="sa-support-body">
//           <div className="sa-section-header">
//             <h3 className="sa-section-title">{t.contact}</h3>
//             <span className="sa-time-badge">
//               <BsClockHistory /> 24/7 Active
//             </span>
//           </div>

//           <div className="sa-grid-options">
            
//             {/* Telegram Card */}
//             <a
//               href={telegramLink}
//               className="sa-contact-card telegram-theme"
//               target="_blank"
//               rel="noreferrer"
//             >
//               <div className="sa-card-glow"></div>
//               <div className="sa-card-left">
//                 <div className="sa-card-icon">
//                   <RiTelegramFill />
//                 </div>
//                 <div className="sa-card-info">
//                   <h4>{t.telegram}</h4>
//                   <span>{t.quick}</span>
//                 </div>
//               </div>
//               <BsArrowRightShort className="sa-card-arrow" />
//             </a>

//             {/* WhatsApp Card */}
//             <a
//               href={whatsappLink}
//               className="sa-contact-card whatsapp-theme"
//               target="_blank"
//               rel="noreferrer"
//             >
//               <div className="sa-card-glow"></div>
//               <div className="sa-card-left">
//                 <div className="sa-card-icon">
//                   <RiWhatsappFill />
//                 </div>
//                 <div className="sa-card-info">
//                   <h4>{t.whatsapp}</h4>
//                   <span>{t.instant}</span>
//                 </div>
//               </div>
//               <BsArrowRightShort className="sa-card-arrow" />
//             </a>

//           </div>

//           {/* Secure Trust Box */}
//           <div className="sa-secure-box">
//             <BsShieldCheck className="sa-shield" />
//             <span>{t.secure}</span>
//           </div>
//         </div>

//       </div>

//       <div className="rightContainer hidden-mobile">
//         <Rightcontainer />
//       </div>
//     </div>
//   );
// };

// export default Support;


import React, { useContext } from "react";
import Rightcontainer from "../Components/Rightcontainer";
import { LanguageContext } from "../Components/LanguageContext";
import { RiTelegramFill, RiWhatsappFill, RiCustomerService2Fill } from "react-icons/ri";
import { BsShieldCheck, BsClockHistory, BsArrowRightShort, BsHeadset, BsChatDots } from "react-icons/bs";
// import "./Support.css";

const Support = () => {
  const { language } = useContext(LanguageContext);

  // Get settings from localStorage safely
  const siteSetting = JSON.parse(localStorage.getItem("sitSetting")) || {};

  const translations = {
    hi: {
      help: "24/7 सहायता केंद्र",
      sub: "क्या आपको कोई समस्या है? हम सहायता के लिए यहाँ हैं",
      contact: "संपर्क माध्यम चुनें",
      telegram: "टेलीग्राम सपोर्ट",
      whatsapp: "व्हाट्सएप चैट",
      quick: "त्वरित प्रतिक्रिया (2-5 मिनट)",
      instant: "इंस्टेंट चैट सहायता",
      secure: "100% सुरक्षित और गोपनीय सहायता",
      online: "ऑनलाइन एजेंट उपलब्ध हैं",
    },
    en: {
      help: "24/7 Support Center",
      sub: "Having an issue? Our team is active & ready to assist",
      contact: "Choose a contact channel",
      telegram: "Telegram Support",
      whatsapp: "WhatsApp Chat",
      quick: "Quick Response (2-5 mins)",
      instant: "Instant live chat support",
      secure: "100% Secure & Confidential Support",
      online: "Live Agents Online",
    },
  };

  const t = translations[language] || translations.en;

  const telegramLink = siteSetting.supportTelegram || "https://t.me/";
  const whatsappLink = siteSetting.whatsappSupport || "https://wa.me/";

  return (
    <div className="sa-luxury-wallet-wrapper leftContainer mt-4 pt-4">
      {/* Dynamic Ambient Background Illumination */}
      <div className="ambient-glow glow-one"></div>
      <div className="ambient-glow glow-two"></div>
      <div className="ambient-glow glow-three"></div>

      <div className="sa-luxury-layout-grid refer-layout-extended">
        
        {/* Master Support Container */}
        <div className="sa-wallet-container refer-master-box support-main-card">
          
          {/* Header Hero Banner */}
          <div className="refer-hero-banner support-hero-banner">
            <div className="hero-glow-effect"></div>
            <div className="banner-badge-wrapper">
              <span className="live-pulse-dot"></span>
              <BsHeadset className="banner-crown" />
              <span>{t.online}</span>
            </div>
            <h1>{t.help}</h1>
            <p>{t.sub}</p>
          </div>

          {/* Section Header Controls */}
          <div className="support-section-header">
            <div className="hub-title-group">
              <BsChatDots size={18} className="hub-icon" />
              <span>{t.contact}</span>
            </div>
            <span className="sa-time-badge">
              <BsClockHistory /> 24/7 Active
            </span>
          </div>

          {/* Channels Grid Options */}
          <div className="support-channels-grid">
            
            {/* Telegram Card */}
            <a
              href={telegramLink}
              className="support-channel-card telegram-card-theme"
              target="_blank"
              rel="noreferrer"
            >
              <div className="channel-card-glow"></div>
              <div className="channel-card-left">
                <div className="channel-icon-wrap telegram-bg-wrap">
                  <RiTelegramFill size={24} />
                </div>
                <div className="channel-info-group">
                  <h4>{t.telegram}</h4>
                  <span>{t.quick}</span>
                </div>
              </div>
              <div className="channel-arrow-box">
                <BsArrowRightShort size={22} />
              </div>
            </a>

            {/* WhatsApp Card */}
            <a
              href={whatsappLink}
              className="support-channel-card whatsapp-card-theme"
              target="_blank"
              rel="noreferrer"
            >
              <div className="channel-card-glow"></div>
              <div className="channel-card-left">
                <div className="channel-icon-wrap whatsapp-bg-wrap">
                  <RiWhatsappFill size={24} />
                </div>
                <div className="channel-info-group">
                  <h4>{t.whatsapp}</h4>
                  <span>{t.instant}</span>
                </div>
              </div>
              <div className="channel-arrow-box">
                <BsArrowRightShort size={22} />
              </div>
            </a>

          </div>

          {/* Secure Trust Box Footer */}
          <div className="support-secure-footer-box">
            <BsShieldCheck className="sa-shield-icon" />
            <span>{t.secure}</span>
          </div>

        </div>

        {/* Right Container Sidebar (Desktop View) */}
        <div className="rightContainer mobile-hide">
          <Rightcontainer />
        </div>

      </div>
    </div>
  );
};

export default Support;